var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileIconBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29.871,
    height: 37.761,
    viewBox: "0 0 29.871 37.761",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_125",
    x: 0,
    y: 0,
    width: 29.871,
    height: 37.761,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#50b2dc",
    floodOpacity: 0.439
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_130",
    x: 7.642,
    y: 3.373,
    width: 13.46,
    height: 19.172,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#50b2dc",
    floodOpacity: 0.439
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_131",
    x: 3.735,
    y: 11.903,
    width: 22.389,
    height: 13.95,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#50b2dc",
    floodOpacity: 0.439
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_132",
    x: 3.736,
    y: 14.873,
    width: 22.395,
    height: 13.949,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#50b2dc",
    floodOpacity: 0.439
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_133",
    x: 12.68,
    y: 3.374,
    width: 14.434,
    height: 19.173,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#50b2dc",
    floodOpacity: 0.439
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_134",
    x: 2.74,
    y: 3.416,
    width: 13.43,
    height: 19.134,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#50b2dc",
    floodOpacity: 0.439
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_135",
    x: 3.73,
    y: 17.855,
    width: 18.155,
    height: 13.941,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#50b2dc",
    floodOpacity: 0.439
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_136",
    x: 3.745,
    y: 20.829,
    width: 18.143,
    height: 13.951,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#50b2dc",
    floodOpacity: 0.439
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_102",
    "data-name": "Groupe 102",
    transform: "translate(-442.894 -711.75)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 442.89, 711.75)",
    filter: "url(#Trac\\xE9_125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_125-2",
    "data-name": "Trac\\xE9 125",
    d: "M447.417,711.75h20.821c.008.106.022.211.022.317q0,10.208,0,20.416a.632.632,0,0,1-.2.5q-1.927,1.909-3.839,3.833c-.063.063-.121.133-.181.2H447.417c-.008-.1-.023-.195-.023-.292q0-12.338,0-24.677C447.395,711.945,447.41,711.847,447.417,711.75Zm1.476,1.488v22.278h13.129v-4.768h4.739v-17.51Zm17.729,19.017h-3.11v3.11Z",
    transform: "translate(-442.89 -711.75)",
    fill: "#50b2dc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 442.89, 711.75)",
    filter: "url(#Trac\\xE9_130)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_130-2",
    "data-name": "Trac\\xE9 130",
    d: "M583.2,769.7h-1.456v-2.208h-1.477v2.2h-1.478c-.005-.075-.014-.146-.014-.218,0-1.4-.008-2.793,0-4.19a2.219,2.219,0,0,1,4.434-.161c.04,1.5.01,3.007.01,4.51A.314.314,0,0,1,583.2,769.7Zm-1.458-3.715c0-.282.014-.536,0-.789a.749.749,0,0,0-.684-.691.708.708,0,0,0-.759.532,6.047,6.047,0,0,0-.01.948Z",
    transform: "translate(-566.63 -759.65)",
    fill: "#50b2dc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 442.89, 711.75)",
    filter: "url(#Trac\\xE9_131)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_131-2",
    "data-name": "Trac\\xE9 131",
    d: "M504.174,894.143v-1.45h13.389v1.45Z",
    transform: "translate(-495.94 -880.79)",
    fill: "#50b2dc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 442.89, 711.75)",
    filter: "url(#Trac\\xE9_132)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_132-2",
    "data-name": "Trac\\xE9 132",
    d: "M504.192,939.28v-1.449h13.395v1.449Z",
    transform: "translate(-495.96 -922.96)",
    fill: "#50b2dc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 442.89, 711.75)",
    filter: "url(#Trac\\xE9_133)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_133-2",
    "data-name": "Trac\\xE9 133",
    d: "M490.878,767.793l1.167-4.747h1.522l-1.636,6.673h-2.163l-1.636-6.667h1.523l1.163,4.733Z",
    transform: "translate(-470.95 -759.67)",
    fill: "#50b2dc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 442.89, 711.75)",
    filter: "url(#Trac\\xE9_134)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_134-2",
    "data-name": "Trac\\xE9 134",
    d: "M657.743,765.136h-1.484v-1.458h4.43v1.452h-1.46v5.182h-1.485Z",
    transform: "translate(-649.02 -760.26)",
    fill: "#50b2dc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 442.89, 711.75)",
    filter: "url(#Trac\\xE9_135)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_135-2",
    "data-name": "Trac\\xE9 135",
    d: "M504.1,984.613v-1.441h9.155v1.441Z",
    transform: "translate(-495.87 -965.32)",
    fill: "#50b2dc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 442.89, 711.75)",
    filter: "url(#Trac\\xE9_136)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_136-2",
    "data-name": "Trac\\xE9 136",
    d: "M513.461,1028.374v1.451h-9.143v-1.451Z",
    transform: "translate(-496.07 -1007.55)",
    fill: "#50b2dc"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIconBlue);
export default __webpack_public_path__ + "static/media/file-icon-blue.d67913cd0aa35bff480bd2774cfb5057.svg";
export { ForwardRef as ReactComponent };